var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"captchaInput",attrs:{"name":"v3_captcha_token","type":"hidden"}})
}
var staticRenderFns = []

export { render, staticRenderFns }